import * as actions from '@r1-frontend/survey/context/actions';
import { SurveyActions } from '@r1-frontend/survey/context/constants/actions';
import initialState, { SurveyInitialState } from '@r1-frontend/survey/context/reducer/initialState';

import { InferValueTypes } from '@r1-frontend/shared/types/Redux';

export type TSurveyActions = ReturnType<InferValueTypes<typeof actions>>

const reducer = (debugMode = false) => (state: SurveyInitialState, action: TSurveyActions): SurveyInitialState => {
    if (debugMode) {
        console.log(action);
        console.table(state);
    }

    switch (action.type) {
        case SurveyActions.SetSurveyButton: {
            return {
                ...state,
                surveyButton: action.payload.surveyButton,
            };
        }
        case SurveyActions.SetCommonSurvey: {
            return {
                ...state,
                survey: [
                    ...state.survey,
                    {
                        ...action.payload.survey,
                        type: 'common',
                    },
                ],
                _initialized: true,
            };
        }
        case SurveyActions.SetContextSurvey: {
            return {
                ...state,
                survey: [
                    ...state.survey,
                    {
                        ...action.payload.survey,
                        type: 'context',
                    },
                ],
                _initialized: true,
            };
        }
        case SurveyActions.Finalization: {
            return { ...initialState };
        }

        case SurveyActions.Loading: {
            return {
                ...state,
                _loading: action.payload.state,
            };
        }

        case SurveyActions.Start: {
            return {
                ...state,
                _toShow: {
                    ...action.payload,
                },
            };
        }
        case SurveyActions.ClosePopup: {
            return {
                ...state,
                _toShow: initialState._toShow,
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default reducer;
